import { useCallback, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import JSON5 from 'json5';
import { useAlerts } from '../../../hooks/use-alerts';
import * as service from '../../../services/admin-service';

export function Products() {
  const { showError, showInfo } = useAlerts();
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [parseError, setParseError] = useState('');

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const data = await service.getZohoProducts();
      setValue(JSON5.stringify(data, null, 2) || '{}');
    } catch (error) {
      showError(error);
    } finally {
      setLoading(false);
    }
  }, [showError]);

  useEffect(() => {
    load();
  }, [load]);

  const handleChange = (e) => {
    const text = e.target.value;
    setValue(text);

    try {
      JSON5.parse(text);
      setParseError('');
    } catch {
      setParseError('Invalid syntax');
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const parsed = JSON5.parse(value);
      await service.saveZohoProducts(parsed);
      showInfo('Zoho products saved');
    } catch (error) {
      showError(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        gap: 2,
      }}
    >
      <TextField
        label="Products"
        multiline
        value={loading ? 'Loading...' : value}
        onChange={handleChange}
        disabled={loading}
        error={!!parseError}
        helperText={parseError}
        sx={{
          flex: 1,
          '& .MuiInputBase-root': { height: '100%', alignItems: 'flex-start' },
          '& .MuiInputBase-input': { fontFamily: 'monospace', fontSize: 14 },
        }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <LoadingButton
          variant="contained"
          onClick={handleSave}
          loading={saving}
          disabled={loading || !!parseError}
        >
          Save
        </LoadingButton>
      </Box>
    </Box>
  );
}
